// extracted by mini-css-extract-plugin
module.exports = {"amenitiesGRDWrapper":"style_amenitiesGRDWrapper__jSUSs"};